import { render, staticRenderFns } from "./promoItemTable.vue?vue&type=template&id=3258d3a8&"
import script from "./promoItemTable.vue?vue&type=script&lang=js&"
export * from "./promoItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VDivider,VIcon,VSpacer,VTextField,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1864693916/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3258d3a8')) {
      api.createRecord('3258d3a8', component.options)
    } else {
      api.reload('3258d3a8', component.options)
    }
    module.hot.accept("./promoItemTable.vue?vue&type=template&id=3258d3a8&", function () {
      api.rerender('3258d3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BatchTables/promoItemTable.vue"
export default component.exports